import cx from "classnames";
import { useShallow } from "zustand/react/shallow";

import { Magnify } from "components/icons/generated";
import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationIsExpanded } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import BaseActionButton from "ds/components/BaseAction/Button";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import KeyboardHint from "ds/components/KeyboardHint";
import Typography from "ds/components/Typography";
import { isMacLike } from "utils/navigator";

import styles from "./styles.module.css";

const MainNavigationSearchButton = () => {
  const isSidebarExpanded = useMainNavigationStore(selectNavigationIsExpanded);
  const { isModalOpen, setModalOpen } = useCommandPaletteStore(
    useShallow((state) => ({
      isModalOpen: state.isModalOpen,
      setModalOpen: state.setModalOpen,
    }))
  );
  const { transitionClasses } = useMainNavigationFadeTransition(!!isSidebarExpanded);

  const handlePress = () => setModalOpen(true);

  return (
    <BaseActionButton
      className={cx(styles.searchButton, {
        [styles.active]: isModalOpen,
        [styles.collapsed]: !isSidebarExpanded,
      })}
      onPress={handlePress}
      justify="start"
      fullWidth
    >
      <Box align="center" gap="medium" grow="1">
        <Icon src={Magnify} color={isSidebarExpanded ? "secondary" : "primary"} noShrink />
        <Typography
          variant="p-body3"
          tag="span"
          color="secondary"
          className={cx(styles.placeholder, transitionClasses)}
        >
          Search Spacelift
        </Typography>
      </Box>
      <KeyboardHint keys={isMacLike ? "⌘K" : "Ctrl+K"} className={transitionClasses} />
    </BaseActionButton>
  );
};

export default MainNavigationSearchButton;
